export const CAMPAIGN_FORM_NAME = 'build-ad-campaign-step';
export const AUDIENCE_FORM_NAME = 'build-ad-audience-step';

export const CAMPAIGN_FIELDS = [ 'objective', 'internalName' ];
export const AUDIENCE_FIELDS = [ 'targeting', 'dateRange', 'payments', 'paymentsConnected' ];



// WEBPACK FOOTER //
// ./src/config/adCreation.js